'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024121 from "./presto.types$-Site-Scope$$anon$121.js";
import * as $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024122 from "./presto.types$-Site-Scope$$anon$122.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteScope$() {
  this.cbM = null;
  this.cbN = false;
  this.cbK = null;
  this.cbL = false;
  this.cbQ = null;
  this.cbR = false;
  this.cbO = null;
  this.cbP = false;
  this.cbS = null;
  this.cbT = false;
}
export { $c_Lpresto_types$SiteScope$ as $c_Lpresto_types$SiteScope$ };
$p = $c_Lpresto_types$SiteScope$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteScope$;
/** @constructor */
function $h_Lpresto_types$SiteScope$() {
}
export { $h_Lpresto_types$SiteScope$ as $h_Lpresto_types$SiteScope$ };
$h_Lpresto_types$SiteScope$.prototype = $p;
$p.cIs = (function() {
  if ((!this.cbN)) {
    this.cbM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cbN = true;
  }
  return this.cbM;
});
$p.iP = (function() {
  if ((!this.cbL)) {
    this.cbK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cbL = true;
  }
  return this.cbK;
});
$p.cIW = (function() {
  if ((!this.cbR)) {
    this.cbQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cbR = true;
  }
  return this.cbQ;
});
$p.cIK = (function() {
  if ((!this.cbP)) {
    this.cbO = new $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024121.$c_Lpresto_types$SiteScope$$anon$121(this);
    this.cbP = true;
  }
  return this.cbO;
});
$p.adO = (function() {
  if ((!this.cbT)) {
    this.cbS = new $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024122.$c_Lpresto_types$SiteScope$$anon$122(this);
    this.cbT = true;
  }
  return this.cbS;
});
var $d_Lpresto_types$SiteScope$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteScope$, "presto.types$SiteScope$", ({
  a1X: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteScope$ as $d_Lpresto_types$SiteScope$ };
var $n_Lpresto_types$SiteScope$;
function $m_Lpresto_types$SiteScope$() {
  if ((!$n_Lpresto_types$SiteScope$)) {
    $n_Lpresto_types$SiteScope$ = new $c_Lpresto_types$SiteScope$();
  }
  return $n_Lpresto_types$SiteScope$;
}
export { $m_Lpresto_types$SiteScope$ as $m_Lpresto_types$SiteScope$ };
//# sourceMappingURL=presto.types$-Site-Scope$.js.map
